export default {
  QUERY_IS_NOT_VALID: 'Query is not valid',
  NO_HITS_FOUND: 'No hits found',
  CANCEL_REQUEST: 'Operation canceled by the user.',
  NETWORK_ERROR: 'Network Error',
};
